export const coerceDateMs = (value: Date | null | number | string | undefined): null | number => {
  if (value == null) return null;
  if (value instanceof Date) {
    const ms = value.getTime();
    return Number.isNaN(ms) ? null : ms;
  }
  const ms = new Date(value).getTime();
  return Number.isNaN(ms) ? null : ms;
};
